module.exports = __webpack_public_path__ + "static/media/co.dc4088d1.svg";